export default __webpack_public_path__ + "static/media/kannada_lang.c6eae219.png";